import { setValueAndMaxLength } from "../../utils/setValueAndMaxLenght";

const ModifyIntakeInput = (props) => {
  const { id, inputRef, nextInputRef, title, unit } = props;
  const [value, setValue] = props.state;
  const isName = props.isName !== undefined;
  const isAmount = props.isAmount !== undefined;

  return (
    <div
      className={
        isName || isAmount
          ? `modify-intake__form-div modify-intake__form-${isName ? "name" : "amount"}-div`
          : "modify-intake__form-nutrient"
      }
    >
      <label className={`modify-intake__form-${isAmount || isName ? "input" : "nutrient"}-title`} htmlFor={id}>
        {title}
      </label>
      {isName ? (
        <input
          className="modify-intake__form-input modify-intake__form-name-input"
          id={id}
          value={value}
          onChange={(e) => {
            if (/^[a-zA-Z ]*$/g.test(e.target.value)) {
              setValue(e.target.value);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && nextInputRef) {
              e.preventDefault();
              nextInputRef.current.focus();
            }
          }}
          onWheel={() => {
            inputRef.current.blur();
          }}
          maxLength={25}
          ref={inputRef}
        />
      ) : (
        <div className={`modify-intake__form-${isAmount ? "amount" : "nutrient"}-input-div`}>
          <input
            className="modify-intake__form-nutrient-input modify-intake__form-number-input"
            id={id}
            value={value}
            onChange={(e) => {
              setValueAndMaxLength(e, setValue, 4);
            }}
            onKeyDown={(e) => {
              if (e.key !== "Enter") return;
              e.preventDefault();
              if (nextInputRef) {
                nextInputRef.current.focus();
              } else {
                inputRef.current.blur();
              }
            }}
            onWheel={() => {
              inputRef.current.blur();
            }}
            type="number"
            ref={inputRef}
          />
          <span className={`modify-intake__form-${isAmount ? "amount" : "nutrient"}-unit`}>{unit}</span>
        </div>
      )}
    </div>
  );
};

export default ModifyIntakeInput;
